import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { Calendar, Clock, Users } from 'lucide-react'
import api from '../../services/api'

function stripMarkdown(text) {
  if (!text) return ''
  return text
    .replace(/[*_~`#>[\]()!-]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

function formatEventDate(dateStr) {
  const d = new Date(dateStr)
  return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })
}

function formatEventTime(dateStr) {
  return new Date(dateStr).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
}

export default function PromotionalEvents() {
  const [events, setEvents] = useState([])

  useEffect(() => {
    api
      .get('/events/promotional')
      .then(({ data }) => setEvents(data.events || []))
      .catch(() => {})
  }, [])

  if (events.length === 0) return null

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className="mb-6"
    >
      <h3 className="text-sm font-semibold text-white/80 uppercase tracking-wider mb-3 flex items-center gap-2">
        <Calendar className="w-4 h-4" />
        Upcoming Free Events
      </h3>
      <div className="space-y-2">
        {events.slice(0, 3).map((occ) => {
          const series = occ.eventSeries || {}
          const spotsLeft = series.maxCapacity
            ? series.maxCapacity - (occ._count?.registrations || 0)
            : null
          return (
            <div
              key={occ.id}
              className="bg-white/10 backdrop-blur-sm rounded-lg p-3 border border-white/10"
            >
              <p className="font-medium text-white text-sm truncate">{series.title}</p>
              {series.description && (
                <p className="text-white/60 text-xs mt-0.5 line-clamp-1">
                  {stripMarkdown(series.description)}
                </p>
              )}
              <div className="flex items-center gap-3 mt-1.5 text-xs text-white/70">
                <span className="flex items-center gap-1">
                  <Calendar className="w-3 h-3" />
                  {formatEventDate(occ.startTime)}
                </span>
                {!series.isAllDay && (
                  <span className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    {formatEventTime(occ.startTime)}
                  </span>
                )}
                {spotsLeft !== null && (
                  <span className="flex items-center gap-1">
                    <Users className="w-3 h-3" />
                    {spotsLeft > 0 ? `${spotsLeft} spots left` : 'Full'}
                  </span>
                )}
              </div>
              {series.creator && (
                <p className="text-xs text-white/50 mt-1">
                  Hosted by {series.creator.firstName} {series.creator.lastName}
                </p>
              )}
            </div>
          )
        })}
      </div>
      <p className="text-xs text-white/50 mt-2">Sign up to register for events</p>
    </motion.div>
  )
}
